// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetShopSupplierByIdRequestModel from '../../model/get-shop-supplier-by-id-request-model';
import GetShopSupplierByIdRequestDTO from '../dto/get-shop-supplier-by-id-request-dto';
import dtoSchema from '../schemas/get-shop-supplier-by-id-request-schema';

export default abstract class GetShopSupplierByIdRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetShopSupplierByIdRequestDTO>) {
    super();
    if (data) {
      this.id = data.id;
    }
  }
  /**
  * @type {int64}
  */
  id?: number;

  static toModel(dto: DeepPartial<GetShopSupplierByIdRequestDTO>): GetShopSupplierByIdRequestModel;
  static toModel(dto: DeepPartial<GetShopSupplierByIdRequestDTO> | undefined | null): GetShopSupplierByIdRequestModel | undefined;
  static toModel(dto: DeepPartial<GetShopSupplierByIdRequestDTO> | undefined | null): GetShopSupplierByIdRequestModel | undefined {
    return dto ? new GetShopSupplierByIdRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetShopSupplierByIdRequestModel> | GetShopSupplierByIdRequestModel): GetShopSupplierByIdRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      id: unwrapped.id,
    } as GetShopSupplierByIdRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetShopSupplierByIdRequestModel, can not map to GetShopSupplierByIdRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
